import {
  ANDAR_BAHAR_IDS,
  BACCARAT_IDS,
  BET_ON_TEEN_PATTI_ID,
  BLACKJACK_IDS,
  CASINO_HOLDEM_ID,
  LUCKY7_ID,
  MARBLE_RACE_ID,
  BIG_COCK_KNOCKOUT_ID,
  MATKA_ID,
  ONE_DAY_TEEN_PATTI_IDS,
  ROULETTE_IDS,
  SICBO_IDS,
  THREE_CARD_POKER_ID,
  ULTIMATE_DICE_ID,
  XOC_DIA_IDS,
} from '@ezugi/constants/gameIds';
import { GameName } from '@ezugi/constants/gameNames';
import { queryParams } from '@ezugi/utils/functions/queryParams/queryParams';

export class AppConfig {

  private static instance: AppConfig | null = null;

  private gameId: number;

  private gameName: GameName;

  private constructor() {
    this.gameId = queryParams.getQueryParams().gameId;
    this.gameName = AppConfig.resolveGameName(this.gameId);
  }

  private static readonly gameIdMap = new Map<number, GameName>([
    [ THREE_CARD_POKER_ID, GameName.ThreeCardPoker ],
    [ BET_ON_TEEN_PATTI_ID, GameName.BetOnTeenPatti ],
    [ CASINO_HOLDEM_ID, GameName.CasinoHoldem ],
    [ LUCKY7_ID, GameName.Lucky7 ],
    [ MATKA_ID, GameName.Matka ],
    [ MARBLE_RACE_ID, GameName.MarbleRace ],
    [ BIG_COCK_KNOCKOUT_ID, GameName.BigCockKnockout ],
    [ ULTIMATE_DICE_ID, GameName.UltimateDice ],
  ]);

  private static readonly groupedGameIds: readonly [ readonly number[], GameName][] = [
    [ ONE_DAY_TEEN_PATTI_IDS, GameName.OneDayTeenPatti ],
    [ ANDAR_BAHAR_IDS, GameName.AndarBahar ],
    [ BACCARAT_IDS, GameName.Baccarat ],
    [ BLACKJACK_IDS, GameName.BlackJack ],
    [ ROULETTE_IDS, GameName.Roulette ],
    [ SICBO_IDS, GameName.SicBo ],
    [ XOC_DIA_IDS, GameName.XocDia ],
  ];

  private static resolveGameName(gameId: number): GameName {
    const directMatch = this.gameIdMap.get(gameId);
    if (directMatch) return directMatch;

    for (const [ ids, name ] of this.groupedGameIds) {
      if (ids.includes(gameId)) return name;
    }

    return GameName.Lobby;
  }

  static getInstance(): AppConfig {
    if (!AppConfig.instance) {
      AppConfig.instance = new AppConfig();
    }
    return AppConfig.instance;
  }

  static clearInstance(): void {
    AppConfig.instance = null;
  }

  getGameName(): GameName {
    return this.gameName;
  }

}
